$(document).ready(function(){

$("input:checkbox").on('click', function() {
  // in the handler, 'this' refers to the box clicked on
  var current_click = $(this);

  if (current_click.is(":checked")) {
    // the name of the box is retrieved using the .attr() method
    // as it is assumed and expected to be immutable
    var group = "input:checkbox[name='" + current_click.attr("name") + "']";
    // the checked state of the group/box on the other hand will change
    // and the current value is retrieved using .prop() method
    $(group).prop("checked", false);
    current_click.prop("checked", true);
    var varianst_IID = current_click.val();
 
$('.warebty_pro_Add').html(' <input type="hidden" name="items[1][id]" class="ID_warrenty" value="'+varianst_IID+'">');
     console.log('check')
  } else {
    current_click.prop("checked", false);
    console.log('unchked');
$('.warebty_pro_Add').html('');
  }
});
 });